






import { Component, Vue, Prop, PropSync } from "vue-property-decorator";

@Component
export default class PageLoader extends Vue {
}
